import { Box, Typography, Button } from '@mui/material';
import footerBackground from '../assets/images/contact-banner.png';

const ContactBanner = () => (
  <Box
    sx={{
      backgroundImage: `url(${footerBackground})`,
      backgroundSize: 'cover',
      color: 'white',
      textAlign: 'center',
      py: 5,
      backgroundBlendMode: 'multiply',
      backgroundColor: "#234b13",
      height: '37vh',
      display: 'grid',
      placeItems: 'center',
    }}
  >
    <Typography variant="h3" >
      Get in Touch Today
    </Typography>
    <Typography variant="subtitle1" sx={{ maxWidth: 600, mx: 'auto', mb: 1 }}>
      Contact us for inquiries or to place your order for high-quality Bio Fuel and by-products.
    </Typography>
    <Button variant="contained" color="primary" href='/contact'>
      Contact Us
    </Button>
  </Box>
);

export default ContactBanner;
